<script setup>
import { watch, ref, computed } from "vue";
import { useRoute } from "vue-router";
import HelpImage from "@/assets/help-image.jpg";

const route = useRoute();

/**
 * initPopup: 初次是否弹窗
 */
const { initPopup = false, appParams } = defineProps([
  "initPopup",
  "appParams",
]);

const emit = defineEmits(["confirm", "cancel"]);

const show = ref(false);

watch(
  () => initPopup,
  (val) => {
    if (val) {
      show.value = true;
    }
  },
  {
    immediate: true,
  }
);

const handleConfirm = () => {
  emit("confirm");
};

const handleCancel = () => {
  show.value = false;
  emit("cancel");
};

const toggleShow = (val = true) => {
  show.value = val;
};

const handleHelp = () => {
  show.value = false;
  showImagePreview({
    images: [HelpImage],
    showIndex: false,
    className: "__help-img-preview",
    onClose: () => {
      show.value = true;
    },
  });
};

const handleToHome = () => {
  window.location.href = "https://banxueketang.com/";
};

defineExpose({
  toggleShow,
});
</script>

<template>
  <van-overlay :show="show" @click="show = true" z-index="3500">
    <div class="wrapper">
      <div class="block" @click.stop>
        <div class="container">
          <div class="container-text">温馨提示</div>

          <div class="container-info">
            我们真诚建议您在<span class="container-info-highlight"
              >伴学课堂</span
            >App内使用音、视频、资料等配套资源。
          </div>

          <div class="container-text-btns">
            <div class="container-text-btns-help" @click="handleHelp">
              使用帮助
            </div>
            <div class="container-text-btns-home" @click="handleToHome">
              官网下载
            </div>
          </div>

          <div class="container-btns">
            <div class="container-btns-cancel" @click="handleCancel">
              继续使用
            </div>
            <div class="container-btns-confirm" @click="handleConfirm">
              APP内打开
            </div>
          </div>
        </div>
      </div>
    </div>
  </van-overlay>
</template>

<style lang="scss" scoped>
.wrapper {
  display: flex;
  align-items: center;
  justify-content: center;
  height: 100%;
}
.block {
  box-sizing: border-box;
  width: 319px;
  padding: 24px;
  background-color: #fff;
  border-radius: 24px;
  position: relative;
  display: flex;
  align-items: center;
  justify-content: center;
}

.container {
  width: 100%;
  .container-text {
    font-size: 20px;
    line-height: 28px;
    color: #000000d9;
    font-weight: 600;
    text-align: center;
  }
  .container-info {
    margin-top: 8px;
    font-size: 16px;
    line-height: 24px;
    color: #000000d9;
    font-weight: 400;
  }
  .container-info-highlight {
    margin: 0 4px;
    color: #ff8912ff;
    font-weight: 600;
  }
  .container-btns {
    display: flex;
    justify-content: space-between;
    margin-top: 16px;

    .container-btns-cancel,
    .container-btns-confirm {
      flex: 1;
      height: 40px;
      display: flex;
      justify-content: center;
      align-items: center;
      border-radius: 100px;
      font-size: 16px;
      color: #ffffff;
      cursor: pointer;
    }

    .container-btns-cancel {
      background-color: #f7f7f7;
      color: #000000d9;
    }

    .container-btns-confirm {
      margin-left: 8px;
      font-weight: 600;
      background: linear-gradient(90deg, #ffa431ff 0%, #ff8912ff 100%);
      position: relative;
    }
  }

  .container-text-btns {
    height: 40px;
    display: flex;
    align-items: center;
    justify-content: center;
    color: #00000059;
    font-size: 16px;
    line-height: 24px;
    text-decoration-line: underline;
    text-underline-offset: 2px;
    .container-text-btns-help {
      margin-right: 40px;
    }
    .container-text-btns-home {
    }
  }
}
</style>

<style lang="scss">
.__help-img-preview {
  z-index: 4000 !important;
}
</style>
